<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="Glicemia capilar"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.glicemiaCapilar"
                    @change.native="handleGlicemiaCapilarChange"
                    label="Glicemia capilar"
                    placeholder="000"
                    v-mask="masks.glicemiaCapilar"
                    v-model="data.model.glicemiaCapilar.valor"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mg/dL
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col>
                <rkm-form-radio-group
                    :options="data.form.glicemiaCapilar.momentosColeta"
                    :validations="validations.momentoColeta"
                    label="Momento da coleta"
                    text-field="nome"
                    v-model="data.model.glicemiaCapilar.momentoColetaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxGlicemiaCapilar
                    v-if="data.form.glicemiaCapilar && data.form.glicemiaCapilar.valor"
                    :data="data.form.glicemiaCapilar"
                    title="Glicemia capilar realizada na mesma data, durante o acolhimento."
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>

// Components.
import BoxGlicemiaCapilar from '@/components/ambulatorio/atendimento/components/historico/components/glicemia-capilar/Index'

export default {
    components: {
        BoxGlicemiaCapilar,
    },
    computed: {
        validations() {
            return {
                glicemiaCapilar: {
                    min_value: 0,
                    max_value: 800,
                    required: !!this.data.model.glicemiaCapilar.momentoColetaId,
                },
                momentoColeta: {
                    required: !!this.data.model.glicemiaCapilar.valor,
                },
            }
        },
    },
    data: () => ({
        masks: {
            glicemiaCapilar: '###',
        },
    }),
    methods: {
        handleGlicemiaCapilarChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('glicemiaCapilarChange', event.target.value)
            }
        },
    },
    props: {
        closed: {type: Boolean, default: false},
        data: {type: Object, required: true},
    },
}
</script>